import React from "react";
import {
  IDataTableProps,
  RenderType,
} from "../../../../../../components/Table/interfaces/IDataTableProps";
import {
  IBusinessPolicyCoverage,
  ICoverageRow,
} from "../../../../../../redux/businessPolicy/businessPolicyCoverage/businessPolicyCoverage.types";
import { CustomTextField } from "../../../../../../components/formsComponents";
import { Box, IconButton, SelectChangeEvent } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { DataTable } from "../../../../../../components/Table/DataTable";
import { CurrencyTextField } from "../../../../../../components/CurrencyTextField/CurrencyTextField";
import { MASTER_DROP_DOWN_CODES } from "../../../../../../constants/enums";
import { MasterDropdown } from "../../../../../MasterDropdowns/MasterDropdown";

interface ICoverageSectionProps {
  rows: ICoverageRow[];
  onRowChange: (fieldKey: keyof ICoverageRow, rowIndex: number, value: string) => void;
  onAddRow: (currentRowIndex: number) => void;
  onRemoveRow: (index: number) => void;
}

const CoverageCrimeTableComponent: React.FC<ICoverageSectionProps> = (props) => {
  const { rows, onRowChange, onRemoveRow, onAddRow } = props;

  const handleRowChange =
    (key: keyof ICoverageRow, rowIndex: number) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onRowChange(key, rowIndex, event.target.value);
    };

  const handleRowSelectChange =
    (key: keyof ICoverageRow, rowIndex: number) =>
    (event: SelectChangeEvent<unknown>) => {
      onRowChange(key, rowIndex, event.target.value as string);
    };

  const handleCurrencyRowChange =
    (key: keyof ICoverageRow, rowIndex: number) => (value: string) => {
      onRowChange(key, rowIndex, value);
    };

  const handleRemoveRow = (index: number) => () => {
    onRemoveRow(index);
  };

  const handleNewRow = (currentRowIndex: number) => () => {
    onAddRow(currentRowIndex);
  };


  const crimeTableProps: IDataTableProps = {
    isPagination: false,
    rowsPerPageOptions: 10000,
    uniqueRowKeyName: "coverage",
    columns: [
      {
        key: "coverage",
        headerName: "Coverage",
        fieldName: "coverage",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,

        onRowCellRender: (value, row: ICoverageRow) => {
          return (
            <MasterDropdown
              fullWidth
              sx={{ minWidth: "350px" }}
              value={row.type}
              dropdownCode={
                MASTER_DROP_DOWN_CODES.BUSINESS_POLICY_COVERGAE_CRIME
              }
              onChange={handleRowSelectChange("type", value.column.rowIndex)}
            />
          );
        },
      },
      {
        key: "deductible",
        headerName: "Deductible",
        fieldName: "deductible",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,

        onRowCellRender: (value, row: ICoverageRow) => {
          return (
            <CustomTextField
              type="text"
              fullWidth
              value={row.deductible}
              onChange={handleRowChange("deductible", value.column.rowIndex)}
            />
          );
        },
      },
      {
        key: "co_insurance",
        headerName: "Co-Insurance",
        fieldName: "co_insurance",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,

        onRowCellRender: (value, row: ICoverageRow) => {
          return (
            <CustomTextField
              type="text"
              fullWidth
              value={row.co_insurance}
              onChange={handleRowChange("co_insurance", value.column.rowIndex)}
            />
          );
        },
      },
      {
        key: "limit_amount",
        headerName: "Limit ($)",
        fieldName: "limit_amount",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,

        onRowCellRender: (value, row: ICoverageRow) => {
          return (
            <CurrencyTextField
              fullWidth
              value={row.limit}
              onChange={handleCurrencyRowChange("limit", value.column.rowIndex)}
            />
          );
        },
      },
      {
        key: "rate",
        headerName: "Rate",
        fieldName: "rate",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,

        onRowCellRender: (value, row: ICoverageRow) => {
          return (
            <CurrencyTextField
              fullWidth
              value={row.rate}
              onChange={handleCurrencyRowChange("rate", value.column.rowIndex)}
            />
          );
        },
      },
      {
        key: "Premium",
        headerName: "Premium",
        fieldName: "premimum",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,

        onRowCellRender: (value, row: ICoverageRow) => {
          return (
            <CurrencyTextField
              fullWidth
              value={row.premium}
              onChange={handleCurrencyRowChange("premium", value.column.rowIndex)}
            />
          );
        },
      },

      {
        key: "delete",
        headerName: "",
        fieldName: "add",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,

        onRowCellRender: (value, row: IBusinessPolicyCoverage) => {
          return (
            <Box display={"flex"}>
              <IconButton
                color="error"
                onClick={handleRemoveRow(value.column.rowIndex)}
              >
                <Remove fontSize="small" />
              </IconButton>
              <IconButton
                color="primary"
                onClick={handleNewRow(value.column.rowIndex)}
              >
                <Add fontSize="small" />
              </IconButton>
            </Box>
          );
        },
      },
    ],
    items: rows,
  };

  return <DataTable {...crimeTableProps} />;
};

export const CoverageCrimeTable = React.memo(CoverageCrimeTableComponent);
